import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService, EventEmitterService } from "src/app/shared/services";
import * as JSZip from "jszip";
import { Observable, Subscription } from "rxjs";
import { BreakpointObserver, Breakpoints, BreakpointState } from "@angular/cdk/layout";
import { MatDialog } from "@angular/material/dialog";
import { DueDateDialogComponent } from "../due-date-dialog/due-date-dialog.component";
@Component({
  selector: "app-design-dashboard",
  templateUrl: "./design-dashboard.component.html",
  styleUrls: ["./design-dashboard.component.less"],
  providers: [DatePipe],

})
export class DesignDashboardComponent implements OnInit, AfterViewInit {
  scheduleList: any[] = [];
  imageResponse: any[] = [];
  currentRoomId: any;
  statusList: any[] = [];
  timePeriodList: any[] = [];
  designerList: any[] = [];
  timePeriod: any = "";
  status: any = []; //'01','02','03' ['New','Active'];
  designerid: any = "";
  total: number = 0;
  curPage: number = 1;
  innerWidth: number;
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;
  authValue: any;
  showDropdown: boolean;
  userType: string;
  @ViewChild('notifyTemp') notifyTemp: TemplateRef<any>;
  @ViewChild('errorTemp') errorTemp: TemplateRef<any>;

  currentRowRoomId: any;
  currentDesignerValue: any;
  currentClientName: string;
  currentRowData: any;
  currentIndex: any;
  originalDesignerList = [];
  isLoading = false;
  page: number = 0;
  stageList: any[] = [];
  Math: Math = Math;
  isArchiveView = false;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc'|'' = '';


  MILESTONE_UI: any = {
    intro_delivery: {
      label: 'Awaiting Designer Intro',
      bg: '#FFE1C8',
      color: '#5C3A1E',
      action: 'intro-sent'
    },
    idea_board_delivery: {
      label: 'Awaiting Idea Board',
      bg: '#FFF6BF',
      color: '#5C5C5C',
      action: 'idea-published'
    },
    idea_board_review: {
      label: 'Reviewing Idea Board',
      bg: '#FFE97F',
      color: '#2E2E2E',
      action: 'idea-published'
    },
    concept_board_delivery: {
      label: 'Awaiting Concept Board',
      bg: '#D6E4FF',
      color: '#0C1C31',
      action: 'idea-approved'
    },
    concept_board_review: {
      label: 'Reviewing Concept Board',
      bg: '#AFCBFF',
      color: '#0C1C31',
      action: 'concept-published'
    },
    '3D_design_delivery': {
      label: 'Awaiting Final Design',
      bg: '#C8F5D4',
      color: '#1B3D2F',
      action: 'concept-approved'
    },
    '3D_design_review': {
      label: 'Reviewing Final Design',
      bg: '#afecff',
      color: '#0C1C31',
      action: '3d-published'
    },
  };

  constructor(
    private api: ApiService,
    private matDialog: MatDialog,
    private snackbar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver
  ) {
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.isLoading = true;
    this.userType = JSON.parse(localStorage.getItem("user")).authorization;

  }

  sortData(column: string) {

    if (this.sortColumn === column) {
      this.sortDirection =
        this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applySorting();

    // reset to first page when sorting
    this.curPage = 1;
    this.page = 0;

    this.updatePagedData();

    // ✅ update URL
    this.updateQueryParams();
  }

  applySorting() {

    this.originalScheduleList.sort((a, b) => {

      let valueA: any;
      let valueB: any;

      switch (this.sortColumn) {

        case 'bookingDate':
          valueA = new Date(a.created_date || 0).getTime();
          valueB = new Date(b.created_date || 0).getTime();
          break;

        case 'stage':

          const stageA = a.next_milestone_type || null;
          const stageB = b.next_milestone_type || null;

          // push blank stages to bottom
          if (stageA === null && stageB === null) return 0;
          if (stageA === null) return 1;
          if (stageB === null) return -1;

          valueA = stageA.toLowerCase();
          valueB = stageB.toLowerCase();

          break;

        case 'dueDate':

          const dateA = a.next_milestone_due_date
            ? new Date(a.next_milestone_due_date).getTime()
            : null;

          const dateB = b.next_milestone_due_date
            ? new Date(b.next_milestone_due_date).getTime()
            : null;

          // push blank dates to bottom
          if (dateA === null && dateB === null) return 0;
          if (dateA === null) return 1;
          if (dateB === null) return -1;

          valueA = dateA;
          valueB = dateB;

          break;
      }

      if (valueA < valueB)
        return this.sortDirection === 'asc' ? -1 : 1;

      if (valueA > valueB)
        return this.sortDirection === 'asc' ? 1 : -1;

      return 0;
    });
  }
  updatePagedData() {
    const start = (this.curPage - 1) * 20;
    this.page = this.curPage - 1;

    const startIndex = this.page * 20;
    const endIndex = startIndex + 20;

    this.scheduleList = this.originalScheduleList.slice(startIndex, endIndex);
    this.scheduleList =
      this.originalScheduleList.slice(start, start + 20);
      this.updateQueryParams();
  }

  getMilestoneUI(type: string) {
    if (!type) return { bg: '#ffffff', color: '#333' }; // Default gray for empty

    const key = type;
    const ui = this.MILESTONE_UI[key];

    // if (!ui) {
    //   console.warn(`Mapping missing for: ${key}`);
    //   return { bg: 'red', color: 'white' }; // Red alert if key is missing!
    // }

    return ui;
  }

  archiveView() {
    this.isArchiveView = !this.isArchiveView;
    this.getDesignBookings();

  }

  get allowUser() {
    return ('' + this.userType).includes('9')
  }

  @HostListener("window:resize")
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }


  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.getDesignStatus();
 
    if (
      (
        JSON.parse(localStorage.getItem("user")) &&
        JSON.parse(localStorage.getItem("user")).email &&
        JSON.parse(localStorage.getItem("user")).email
      ).length > 0
    ) {
      this.getAuth();

    } else {
      this.router.navigate(["/"]);
    }
    this.eventEmitterService.userChangeEvent.asObservable().subscribe((res) => {
      if (
        (
          JSON.parse(localStorage.getItem("user")) &&
          JSON.parse(localStorage.getItem("user")).email &&
          JSON.parse(localStorage.getItem("user")).email
        ).length > 0
      ) {
        this.getAuth();

      } else {
        this.router.navigate(["/"]);
      }
    });
  }


  getDesignStausList() {
    this.api.getDesignStausList().subscribe((resp: any) => {
      this.statusList = resp.room_status;
      this.stageList = resp.room_stage?.sort((a, b) => (a.serial - b.serial));
    });
  }
  assignBackStatusDesigner() {

    this.route.queryParamMap.subscribe(params => {
      const statusParam = params.get('status');
      const designerIdParam = params.get('designerid');
      const pageParam = params.get('page');
      this.page = pageParam ? parseInt(pageParam, 10) : 0;
      this.curPage = this.page;
      this.page = this.page > 0 ? this.page - 1 : 0;
      if (statusParam) {
        const codes = statusParam.split(',');
        this.status = this.statusList.filter(s => codes.includes(s.code)).map(m => m.code);
      }

      if (designerIdParam) {
        this.designerid = this.designerList.find(d => d.designerId === designerIdParam)?.designerId;

      }
    });
  }


  getAuth() {
    this.authValue = (JSON.parse(localStorage.getItem("user")).authorization);
    if (this.authValue == 90) {
      this.showDropdown = true;
    } else {
      this.showDropdown = false
    }
  }
  getDesignerName() {
    this.api.getDesignProfile().subscribe((res) => {
      this.designerList = res;
      this.originalDesignerList = JSON.parse(JSON.stringify(res))
      this.designerList.unshift({ designerId: '', first_name: '', last_name: '' })
      this.assignBackStatusDesigner();
      this.getDesignBookings();


    });
  }

  updateQueryParams() {

    const statusValues = this.status.join(',');
    const designerId = this.designerid;

    const currentParams = { ...this.route.snapshot.queryParams };

    // STATUS
    if (statusValues) currentParams['status'] = statusValues;
    else delete currentParams['status'];

    // DESIGNER
    if (designerId) currentParams['designerid'] = designerId;
    else delete currentParams['designerid'];

    // PAGE
    if (this.page >= 0) currentParams['page'] = this.page + 1;
    else delete currentParams['page'];

    // ✅ SORT COLUMN
    if (this.sortColumn)
      currentParams['sort'] = this.sortColumn;
    else
      delete currentParams['sort'];

    // ✅ SORT DIRECTION
    if (this.sortDirection)
      currentParams['dir'] = this.sortDirection;
    else
      delete currentParams['dir'];

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
      queryParamsHandling: '' // replace params cleanly
    });
  }

  openDueDateDialog(row: any, type: string) {
    this.matDialog.open(DueDateDialogComponent, {
      width: '400px',
      data: {
        dueDate: row.next_milestone_due_date,
        rowData: row,
        type: type
      }
    }).afterClosed().subscribe(result => {
      // if (result) {
      this.getDesignBookings();
      // }
    });
  }

  pageChanged(event: number) {
    this.curPage = event;
    this.updatePagedData();
  }

  getSortIcon(column: string) {

    if (this.sortColumn !== column) {
      return 'unfold_more'; // both arrows
    }

    return this.sortDirection === 'asc'
      ? 'arrow_upward'
      : 'arrow_downward';
  }


  originalScheduleList: any[] = [];
  getDesignBookings() {
    this.scheduleList = [];
    this.isLoading = true;
    let finalStatus = this.status;
    if (this.status.includes('any')) {
      finalStatus = ''
    }
    this.api
      .getAllDesignBookings(finalStatus, this.designerid, this.timePeriod, this.page, this.isArchiveView ? '1' : '0')
      .subscribe((res: any) => {
        this.total = res.total || 0;
        this.updateQueryParams();
        if (this.total == 0) {
          this.scheduleList = [];
        } else {
          this.scheduleList = [...res.data];// [...this.scheduleList, ...res.data];
        }
        this.scheduleList.forEach((f) => {
          f.isEdit = false;
          f.copyIcon = false;
          f.emailIcon = false;
          f.editDesigner = false;
          f.triggerEmailIcon = false;
          f.editStatus = false;
          f.editStage = false;
          // f.next_milestone_type = 'intro_delivery'
          f.orderList = f.order_ids ? f.order_ids.split(',') : [];
          if (f.orderList.length > 1) {
            f.orderList.unshift('');
          }
          f.actual_next_milestone_due_date = f.next_milestone_due_date;
          f.next_miletone_type = f.next_milestone_type;
          f.next_milestone_due_date = f.status==='03' || f.status==='05' ? f.next_milestone_due_date : null;
          f.next_milestone_type = f.status==='03' || f.status==='04' ? f.next_milestone_type : null;
          f.schedule = this.getPstTime(f.schedule_date);
          f.roomval = this.api.getRoomValue(f.room);
          f.deliveryValue = this.api.getDeliveryValue(f.delivery_speed);
          // f.stageVal = this.stageList.find(s => s.code === f.stage);
          // f.stageData = this.stageList.find(s => s.code === f.stage)?.label;
          f.next_milestone_type = f.next_milestone_type ? f.next_milestone_type : '';

        });
        this.originalScheduleList = JSON.parse(JSON.stringify(this.scheduleList));
        if (this.sortColumn) {
          this.applySorting();
        }

        this.updatePagedData();
        this.isLoading = false;


      }, err => {
        this.isLoading = false;

      });

  }
  sendMail(roomId) {
    this.api.sendMailDesigner(roomId).subscribe((res: any) => {
      if (res && res.status) {
        this.snackBar.open('Mail sent successfully', 'x', {
          duration: 2000,
        })
        this.matDialog.closeAll();
      } else {
        this.snackBar.open('Mail not sent', 'x', {
          duration: 2000,
        })
      }
    }, err => {
      this.snackBar.open('Mail not sent', 'x', {
        duration: 2000,
      })
    })
  }
  showDesigner(i) {
    // const index = ((this.curPage - 1) * 20) + i;
    this.scheduleList[i].editDesigner = true;
  }
  showStatus(i) {
    // const index = ((this.curPage - 1) * 20) + i;
    this.scheduleList[i].editStatus = true;
  }

  @ViewChildren('milestoneSelect') selects!: QueryList<ElementRef<HTMLSelectElement>>;

  showStage(i: number) {
    if (this.scheduleList[i].next_milestone_type !== 'intro_delivery') {
      this.scheduleList[i].editStage = true;
    } else {
      this.openDueDateDialog(this.scheduleList[i], 'stage');
    }

    // setTimeout(() => {
    //   // const td = event.currentTarget as HTMLElement;
    //   const select = this.selects.toArray()[i]?.nativeElement as HTMLSelectElement;
    //   select?.focus();
    // },1000);
  }


  getStatus(s) {
    if (this.statusList.length > 0) {
      return this.statusList?.find(f => f.code === s)?.label;
    }
    return '';
  }
  getDesigner(s) {
    if (this.designerList.length > 0) {
      const dat = this.designerList?.find(f => (f.designerId) === (s.designer_assigned));
      if (dat) {
        return dat.first_name + ' ' + dat.last_name;

      } else {
        return '';

      }
    }
    return '';
  }
  getName(name: string): string {
    return name?.replace(/([A-Z])/g, ' $1').trim();
  }

  callUpdateAPI(callMail = false) {
    const data = { "room_id": this.currentRowRoomId, "designer_assigned": this.currentDesignerValue }
    this.api.updateAssignedDesigner(data).subscribe(res => {
      if (res) {
        this.scheduleList[this.currentIndex].editDesigner = false;

        this.snackBar.open('Designer Updated Successfully', 'x', {
          duration: 2000,
        })
        if (this.currentDesignerValue && callMail) {
          this.sendMail(this.currentRowRoomId);
          this.scheduleList[this.currentIndex].editDesigner = false;
        }
      } else {
        this.snackBar.open('Api error', 'x', {
          duration: 2000,
        })
      }
    }, err => {
      this.snackBar.open('Api error', 'x', {
        duration: 2000,
      })
    })
  }
  closeDialog() {
    this.matDialog.closeAll();
  }

  updateDesigner(s, event, i) {
    this.currentRowData = s;
    this.currentIndex = i;
    this.currentRowRoomId = s.room_id;
    this.currentDesignerValue = event.target.value;
    this.currentClientName = s.firstName ? s.firstName : 'this room';
    if (this.currentDesignerValue == '') {
      this.callUpdateAPI();
    } else {
      this.matDialog.open(this.notifyTemp, {
        width: '450px',
        disableClose: true
      }).afterClosed().subscribe(result => {
        if (result) {
          this.callUpdateAPI();
        }
      });
    }

  }

  showCopy(i) {
    // const index = ((this.curPage - 1) * 20) + i;

    this.scheduleList.forEach(f => f.copyIcon = false);
    if (this.scheduleList[i]) {
      this.scheduleList[i].copyIcon = true;
    }
  }
  hideCopy(i) {
    const index = i;// ((this.curPage - 1) * 20) + i;
    if (this.scheduleList[index]) {

      this.scheduleList[index].copyIcon = false;
    }
  }


  showEmail(i) {

    // const index = ((this.curPage - 1) * 20) + i;
    this.scheduleList.forEach(f => { f.emailIcon = false; f.triggerEmailIcon = false });
    if (this.scheduleList[i]) {
      this.scheduleList[i].emailIcon = true;
      this.scheduleList[i].triggerEmailIcon = true;
    }
  }
  hideEmail(i) {
    // const index = ((this.curPage - 1) * 20) + i;
    if (this.scheduleList[i]) {

      this.scheduleList[i].emailIcon = false;
      this.scheduleList[i].triggerEmailIcon = false;
    }
  }
  copyToClipboard(text) {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Text copied to clipboard");
        })
        .catch((err) => {
          console.error("Could not copy text: ", err);
        });
    } else {
      // Fallback for browsers that do not support Clipboard API
      // this.fallbackCopyTextToClipboard(text);
    }
  }

  getPstTime(date: any) {
    let dateObj: Date = typeof date == "string" ? new Date(date) : date;
    if (dateObj) {
      let offset = 7 * 60 * 60 * 1000;
      dateObj.setTime(dateObj.getTime() - offset);
      return dateObj;
    }
  }

  getDesignStatus() {
    this.api.getDesignStausList().subscribe((resp: any) => {
      this.statusList = resp.room_status;
      this.stageList = resp.room_stage?.sort((a, b) => (a.serial - b.serial));


      this.getDesignerName();
         this.route.queryParams.subscribe(params => {

      // existing params
      if (params.page) {
        this.curPage = +params.page;
        this.page = this.curPage - 1;
      }

      // ✅ LOAD SORT COLUMN
      if (params.sort) {
        this.sortColumn = params.sort;
      }

      // ✅ LOAD SORT DIRECTION
      if (params.dir === 'asc' || params.dir === 'desc') {
        this.sortDirection = params.dir;
      }

      if(params.designerid){
        this.designerid = params.designerid;
      }

       if(params.status){
        const codes = params.status.split(',');
        this.status = this.statusList.filter(s => codes.includes(s.code)).map(m => m.code);
      }

      // apply sorting after data load
      this.applySorting();
      this.updatePagedData();
    });

    });
  }

  clearStatus() {
    this.status = [];
    this.getDesignBookings();
    this.curPage = 1;

  }

  onStatusChange() {
    this.page = 0;
    this.getDesignBookings();
  }
  errormsg: string = "";
  errorCode: string = "";
  saveDesignStatus(s, e, type) {
    this.errormsg = "";
    let obj = {};
    if (type === 'status') {
      obj = {
        room_id: s.room_id,
        status: e,

      };
    }

    if (type === 'milestone') {
      obj = {
        room_id: s.room_id,
        stage: this.MILESTONE_UI[e]?.action,

      };
    }

    this.api.updateDesignStatus(obj).subscribe((resp: any) => {
      if (resp && resp.success) {
        this.snackbar.open("Status updated successfully", "x", {
          duration: 2000,
        });
        this.getDesignBookings();
      } else {
        const data = this.originalScheduleList.find(f => f.room_id === s.room_id);
        s.next_milestone_type = data.next_milestone_type;
        this.errormsg = resp.message || "Error updating status";
        this.errorCode = resp.error_code;

        this.matDialog.open(this.errorTemp, {
          width: '450px',
          disableClose: true
        });

      }
    }, err => {
      const data = this.originalScheduleList.find(f => f.room_id === s.room_id);
      s.next_milestone_type = data.next_milestone_type;
      this.errormsg = err.error.message || "Error updating status";
      this.errorCode = err.error.error_code;

      this.matDialog.open(this.errorTemp, {
        width: '450px',
        disableClose: true
      });
    });
  }

  schedule() {
    let payload = {
      room_id: "",
    };
    this.api.sendDesignBookingMail(payload).subscribe((res) => {
      this.snackbar.open("Mail scheduled successfully", "x");
      this.getDesignBookings();
    });
  }

  ngAfterViewInit(): void {
    this.hideIntercomIcon();
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);

    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }

  goToPage(page) {
    if (page === -1) {
      this.curPage = Math.ceil(this.scheduleList.length / 10);
    } else {
      this.curPage = page;
    }

  }

  get isLastPage() {
    return this.curPage === Math.floor(this.scheduleList.length / 10);
  }

  getColor(order) {
    const orderCode = this.statusList.filter(
      (val) => val.code === order.status
    )[0];
    if (orderCode) {
      return {
        "background-color": orderCode.bg_hex,
        color: orderCode.font_hex, //'white',
        padding: "6px 5px 3px 5px",
        "border-radius": "8px",
      };
    }
  }
  getServerDate(date: any): any {
    const y = new Date(date).toISOString();
    return y;
  }
  getDesignImages(data: any) {
    this.currentRoomId = data.room_id;
    this.api.getDesignImages(this.currentRoomId).subscribe((res: any) => {
      if (res && res.length > 0) {
        res.forEach((f) => {
          if (f.image) {
            const imageUrl =
              `/${this.currentRoomId}/client_submission/` +
              f.image.split(`/${this.currentRoomId}/client_submission/`)[1];
            this.getImages(
              f.image,
              f.image.split(`/${this.currentRoomId}/client_submission/`)[1],
              res
            );
          }
        });
      }
    });
  }
  getImages(data: any, name: string, fullData: any[]) {
    this.api.getImageBlob(data).then((res) => {
      this.imageResponse.push({ name: name, content: res });
      if (fullData.length === this.imageResponse.length) {
        this.downloadZip();
      }
    });
  }
  async downloadZip() {
    const files = this.imageResponse;

    const zip = new JSZip();

    for (const file of files) {
      zip.file(file.name, file.content);
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(zipBlob);
    link.download = `${this.currentRoomId}_documents.zip`;
    link.click();
  }
  goToIntake(s) {
    this.router.navigate([
      `admin/dashboard/design/rooms/${s.room_id}/profile`,
    ]);
  }
  openOrder(s) {
    if (s) {
      // this.router.navigate([]).then(() => {
      window.open(`admin/dashboard/orders/${s}/summary`);
      // });

    }
  }
  onProfileChangeAck(s:any){
    this.api.markRoomProfileChangesSeen(s.room_id).subscribe((res:any) => {
      if(res){
        // this.snackbar.open('Acknowledged changes', 'x', {
        //   duration: 2000,
        // });
        s.has_unseen_profile_changes = 0;
        // this.getDesignBookings();
      } else {
        this.snackbar.open('Error acknowledging changes', 'x', {
          duration: 2000,
        });
      }
    });
  }
}
